export default __webpack_public_path__ + "static/media/plugin-beta-step1.24638bb1.gif";